var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "input-group" },
    [
      _c("div", { staticClass: "input-group-prepend" }, [
        _c(
          "button",
          {
            staticClass: "input-group-text rounded-0",
            class: _vm.locationClass,
            on: {
              click: function ($event) {
                return _vm.getMyLocation()
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "15",
                  height: "22",
                  viewBox: "0 0 15 22",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M7.5419 0C11.648 0 15 3.29588 15 7.41573C15 10.2172 9.30168 18.7865 7.5419 22C5.69832 18.7865 0 10.2172 0 7.41573C0 3.29588 3.35196 0 7.5419 0ZM7.5419 3.70787C9.30168 3.70787 10.8101 5.10861 10.8101 6.92135C10.8101 8.73408 9.30168 10.1348 7.5419 10.1348C5.69832 10.1348 4.18994 8.73408 4.18994 6.92135C4.18994 5.10861 5.69832 3.70787 7.5419 3.70787Z",
                    fill: `#${_vm.iconColor}`,
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
      _c(
        "b-form-select",
        {
          staticClass: "rounded-0 agile-select",
          attrs: {
            options: _vm.locations,
            "value-field": "id",
            "text-field": "name",
          },
          model: {
            value: _vm.internalValue,
            callback: function ($$v) {
              _vm.internalValue = $$v
            },
            expression: "internalValue",
          },
        },
        [
          _c("b-form-select-option", { attrs: { value: 0, disabled: "" } }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }